module.exports = __webpack_public_path__ + "img/collection-engagementRingsLabGrownDiamonds.b7d8e16.jpg";